(() => {
  const initialize = () => {
    document.querySelectorAll('[data-purchase-total]').forEach(total => {
      if (total.dataset.ready) return;
      const form = document.getElementById(total.dataset.productForm);
      const container = total.closest('.product__info-container');
      if (!form || !container) return;
      let prices;
      try { prices = JSON.parse(total.querySelector('[data-purchase-prices]').textContent); } catch { return; }
      total.dataset.ready = 'true';
      const output = total.querySelector('[data-purchase-total-value]');
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:total.dataset.currency || 'USD'});
      const update = () => {
        const variant = form.querySelector('[name="id"]')?.value;
        const price = prices[variant];
        if (price === undefined) { total.hidden = true; return; }
        total.hidden = false;
        const quantity = Math.max(1, Number([...form.elements].find(el=>el.name==='quantity')?.value || 1));
        const controller=form.querySelector('tints-addons');
        const amount=format.format((controller?.total ? controller.total(price,quantity) : price*quantity)/100);
        if (output.textContent!==amount) output.textContent=amount;
        const express=form.querySelector('.shopify-payment-button');
        if(express) express.hidden=Boolean(form.querySelector('[data-addon-toggle]:checked'));
      };
      container.addEventListener('change',update);
      container.addEventListener('input',update);
      container.addEventListener('addons:change',update);
      new MutationObserver(update).observe(container,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
